/**
 * Sortable column header — minimal helper used inside `<th>` cells.
 *
 * Caller passes the current `sort = { key, dir }` and a `setSort` callback.
 * Clicking the header cycles: idle → asc → desc → idle.
 */
import React from 'react';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

const SortableHeader = ({ label, columnKey, sort, setSort, align = 'left' }) => {
  const active = sort.key === columnKey;
  const dir = active ? sort.dir : null;

  const onClick = () => {
    if (!active) { setSort({ key: columnKey, dir: 'asc' }); return; }
    if (dir === 'asc') { setSort({ key: columnKey, dir: 'desc' }); return; }
    setSort({ key: null, dir: null });
  };

  const Icon = dir === 'asc' ? ArrowUp : dir === 'desc' ? ArrowDown : ArrowUpDown;

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={`sort-${columnKey}`}
      className={`inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider transition-colors ${
        active ? 'text-emerald-700' : 'text-slate-500 hover:text-slate-700'
      } ${align === 'right' ? 'flex-row-reverse' : ''}`}
    >
      <span>{label}</span>
      <Icon className="h-3 w-3 opacity-70" />
    </button>
  );
};

export default SortableHeader;
